/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { DirectorySpotlight } from "@cosmos/components";

import { InstructorCard } from "./cards/InstructorCard";

import type { Instructor } from "@cosmos/airtable-data";

export interface InstructorSpotlightProps {
	instructors: Instructor[];
}

/**
 * Weekly Spotlight strip for the GoldInstructors variant — wraps the generic
 * `DirectorySpotlight` from `@cosmos/components` with the Instructor-specific
 * card adapter. Domain coupling lives here (in next-templates), not in the
 * design system.
 */
export function InstructorSpotlight({ instructors }: InstructorSpotlightProps): React.JSX.Element | null {
	return (
		<DirectorySpotlight<Instructor>
			items={instructors}
			getKey={(i) => i.id}
			renderCard={(instructor) => <InstructorCard data={instructor} />}
		/>
	);
}
